import axios from 'axios';
import { API_BASE_URL, apiUrl } from './config';

/**
 * Public API Client - for endpoints that don't require authentication
 * Bypasses the global interceptor to allow anonymous access
 */
const publicApi = axios.create({
  baseURL: API_BASE_URL
});

// No auth interceptor - these are public endpoints
publicApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Let errors propagate without redirecting to login
    // Don't treat 429 (throttle) as auth error
    if (error.response?.status === 429) {
      console.warn('Rate limit reached:', error.response.data);
    }
    return Promise.reject(error);
  }
);

/**
 * Get all boards/curriculums (public endpoint)
 */
export const getPublicBoards = async () => {
  try {
    const response = await publicApi.get(apiUrl('superadmin/boards/'));
    return response.data || [];
  } catch (error) {
    console.error('Error fetching boards:', error);
    throw error;
  }
};

/**
 * Get all grades (public endpoint)
 */
export const getPublicGrades = async () => {
  try {
    const response = await publicApi.get(apiUrl('superadmin/grades/'));
    return response.data || [];
  } catch (error) {
    console.error('Error fetching grades:', error);
    throw error;
  }
};

export default publicApi;
